// extracted by mini-css-extract-plugin
export var loadingSpinner = "_w-0";
export var spinnerContainer = "_w-1";